import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProduitService } from '../../services/produit.service';

@Injectable()
export class ProduitResolver implements Resolve<Observable<string>> {

  constructor(
    private produitService: ProduitService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    const url_instance = route.paramMap.get('url_instance');

    return this.produitService.getInstanceIds(url_instance).pipe(map(
      (res) => {
        return res;
      }),
      catchError(err => {
        return empty();
      }
    ));
  }

}
